<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title style="color:#1C2546;margin-top:40px">Autorizaciones Temporales</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-divider ></v-divider>
        </v-toolbar>
        <v-tabs fixed-tabs>
            <!-- Tabs de la pantalla -->
            <v-tab>Personal</v-tab>
            <v-tab>Autorizaciones Temporales</v-tab>
            <!-- Tabs -->
            <!-- Tab del personal al cual dale permisos -->
            <v-tab-item>
                <v-data-table :search="searchDisponibles" :headers="headers_disponibles"  :items="disponibles"  class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchDisponibles" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="getEmpleados(item)" >mdi-badge-account</v-icon>
                        <v-icon v-if="item.puesto_jefe != 'CEO'" small class="mr-2" @click="autorizeTemp(item)" >mdi-account-convert</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>
            <!-- Tab de personal con permisos -->
            <v-tab-item>
                <v-data-table  :search="searchAutorizados"  :headers="headers_autorizados"  :items="autorizados"  class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchAutorizados" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="restoreAut(item)" >mdi-backup-restore</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs>
        <!-- Dialogs -->
        <!-- Dialog de confirmar restaurar autorizacion -->
        <v-dialog v-model="ConfirmRestoreAut" max-width="590">
            <v-card>
              <v-card-title class="headline"> Restaurar Autorizaciones </v-card-title>
              <v-card-text> ¿Estás seguro que desea retirar las autorizaciones temporales de este empleado? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="ConfirmRestoreAut = false">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="ConfirmRestoreAutorizacion">Confirmar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog de confirmar delegar autorizacion --> 
        <v-dialog v-model="ConfirmAutTem" max-width="590">
            <v-card>
              <v-card-title class="headline"> Delegar Autorizaciones </v-card-title>
              <v-card-text>¿Estás seguro que desea delegar las autorizaciones al jefe inmediato superior?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="ConfirmAutTem = false" >Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="ConfirmAutorizeTemp" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog de empleados a cargo de un puesto -->
        <v-dialog v-model="checkEmp" max-width="60%">
            <v-card>
              <v-card-title class="headline">Empleados a Cargo</v-card-title>
              <v-card-text>
                 <v-data-table :search="searchEmpleados" :headers="headers_empleados" :items="empleadosACargo" class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchEmpleados" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
              </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import router from '../router/index.js';

export default {
    data(){
        return {
            searchDisponibles : '',
            searchAutorizados : '',
            headers_disponibles:[
                { text: "Personal",value: "nombre_empleado_superior", sortable: true},
                { text: "Puesto",value: "nombre_puesto_superior", sortable: true},
                { text: "Acciones", value: "actions", sortable: false }
            ],
            headers_autorizados:[
                { text: "Nombre Personal Autorizado", value: "nombre_empleado_superior", sortable: true },
                { text: "Puesto Personal Autorizado",value: "nombre_puesto_superior", sortable: true},
                { text: "Acciones", value: "actions", sortable: false }
            ],
            disponibles: [],
            autorizados: [],
            alertSucess: false,
            message: '',
            alertError: false,
            ConfirmAutTem: false,
            ConfirmRestoreAut: false,
            selectedRow: null,
            checkEmp: false,
            searchEmpleados: '',
            headers_empleados: [
                { text: "Empleado",value: "empleado", sortable: true },
                { text: "Puesto",value: "puesto", sortable: true },
            ],
            empleadosACargo: [],
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        // End config for axios
        this.getDisponibles();
        this.getAutorizados();
    },
    methods: {
        getDisponibles() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/autorizaciones/temporales/disponibles").then(res => {this.disponibles = res.data;});
        },
        getAutorizados() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/autorizaciones/temporales/autorizados").then(res => {this.autorizados = res.data;});
        },
        autorizeTemp(item){
            this.selectedRow = item;
            this.ConfirmAutTem = true;
        },
        ConfirmAutorizeTemp(){
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/autorizaciones/temporales/autorizar",{ id_jefe_directo: this.selectedRow.id_puesto_superior, complete_row: this.selectedRow }).then(res => {
                this.getDisponibles();
                this.getAutorizados();
                this.message = res.data.message;
                this.alertSucess = true;
                this.ConfirmAutTem = false;
            })
        },
        restoreAut(item){
            this.selectedRow = item;
            this.ConfirmRestoreAut = true;
        },
        ConfirmRestoreAutorizacion(){
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/autorizaciones/temporales/desautorizar",{id_jefe_directo: this.selectedRow.id_puesto_superior, id_empleado_superior: this.selectedRow.id_empleado_superior, complete_row: this.selectedRow}).then(res => {
                this.getDisponibles();
                this.getAutorizados();
                this.message = res.data.message;
                this.alertSucess = true;
                this.ConfirmRestoreAut = false;
            })
        },
        getEmpleados(item) {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/autorizaciones/temporales/empleados/"+item.id_puesto_superior).then(res => {
                this.empleadosACargo = res.data;
                this.checkEmp = true;
            });
        },
    }  
}
</script>
<style></style>